var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{class:_vm.$style.pageTitle},[_vm._v(" Company Profile ")]),_vm._l((_vm.modules),function(module){return _c('navigation-item',{key:module.id,attrs:{"module":module,"active-module":_vm.activeModule}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }